import { Box, Stack } from "@mui/material";
import { Navigate } from "react-router";
import { DashboardBackground } from "../../modules/dashboard/components/dashboard-background";
import { DashboardHeader } from "../../modules/dashboard/components/dashboard-header";
import { RecentProgramsCard } from "../../modules/dashboard/components/recent-programs-card";
import { RecentlyEditedSection } from "../../modules/dashboard/components/recently-edited-section";
import { WhatsNewCard } from "../../modules/dashboard/components/whats-new-card";
import { Page } from "../../modules/layout/components/page";
import { PageContent } from "../../modules/layout/components/page-content";
import { useFlags } from "../../server/optimizely";

import type { FC } from "react";

const DashboardPage: FC = () => {
  const {
    flags: { cha_4551_dashboard_2026 },
    flagsLoaded,
  } = useFlags("cha_4551_dashboard_2026");

  if (!flagsLoaded) return null;
  if (!cha_4551_dashboard_2026) return <Navigate replace to="/" />;

  return (
    <Page
      title="Home | ChangeEngine"
      sx={{ position: "relative", isolation: "isolate", overflow: "hidden", minHeight: "100vh" }}
    >
      <DashboardBackground />
      <PageContent maxWidth="lg" mt={4}>
        <Stack spacing={4}>
          <DashboardHeader />
          <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={2}>
            <RecentProgramsCard />
            <WhatsNewCard />
          </Box>
          <RecentlyEditedSection />
        </Stack>
      </PageContent>
    </Page>
  );
};

export default DashboardPage;
